import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog"
import { SocialLoginButtons } from "./SocialLoginButtons";
import { useTranslation } from "react-i18next";

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (data: { isNewAccount: boolean }) => void;
}

export function LoginModal({ isOpen, onClose, onSuccess }: LoginModalProps) {
  const { t } = useTranslation('common');

  const handleLoginSuccess = (data: { isNewAccount: boolean }) => {
    onClose();
    onSuccess?.(data);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">{t('auth.login')}</DialogTitle>
          <DialogDescription className="text-center">
            {t('auth.loginDescription')}
          </DialogDescription>
        </DialogHeader>
        <div className="pt-4">
            <SocialLoginButtons onLoginSuccess={handleLoginSuccess} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
